// extracted by mini-css-extract-plugin
export const link__base = "header-module--link__base--35gU7";
export const link__sublink = "header-module--link__sublink--25Pb9";
export const dropdown = "header-module--dropdown--2--nx";
export const header = "header-module--header--1SiOw";
export const menuItems = "header-module--menuItems--3FreH";
export const menuIcon = "header-module--menuIcon--16iCa";
export const link__active = "header-module--link__active--1_QcS";
export const dropdownItems = "header-module--dropdownItems--3vBZk";